import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks';

type Props = {
    children: ReactElement | ReactElement[]
}

export const RedirectHandler = ({ children } : Props) => {
    const { hasInsiderRoles } = useAuth();
    const location = useLocation();

    if (!hasInsiderRoles && location.pathname !== '/hr') {
        return <Navigate to="/hr" />;
    }

    return <>{children}</>;
};